<ion-header>
  <ion-toolbar class="header-color ion-text-center">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
        <img class="brand-logo" src="assets/images/promoga-logo-web.png">
    </ion-title>
  </ion-toolbar>
  <app-promoga-alert></app-promoga-alert>
</ion-header>

<ion-content>
  <ion-row>
    <ion-col>
      <div class="hero text-center">
        <div class="hero-content">
          <div class="hero-content__bottom">
            <h3 class="text-center">
              Book yoga, dance and fitness classes with independent instructors
            </h3>
            <div class="search-wrapper">
              <ion-searchbar searchIcon="location" [(ngModel)]="selectedPlace" (click)="showAddressModal()" placeholder="Vancouver, BC"></ion-searchbar>
              <div class="search-label">
                <svg width="30" height="30" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M36.4226 12.5396C42.0326 18.1496 42.7526 26.7896 38.5826 33.2096C38.9426 33.5096 39.2426 33.8396 39.6626 34.1396C40.2626 34.6196 41.0726 35.2196 42.0926 35.9096C43.1126 36.6296 43.7726 37.0796 44.0726 37.3196C45.3326 38.2496 46.2626 39.0296 46.8926 39.6596C47.8526 40.6196 48.6926 41.6096 49.4126 42.6596C50.1626 43.7096 50.7326 44.7296 51.1826 45.7796C51.6026 46.8296 51.8126 47.8196 51.7226 48.7796C51.6626 49.7396 51.3026 50.5496 50.6426 51.2096C49.9826 51.8696 49.1726 52.2296 48.2126 52.2896C47.2826 52.3496 46.2626 52.1696 45.2426 51.7196C44.1926 51.2996 43.1426 50.6996 42.1226 49.9496C41.0726 49.2296 40.0826 48.3896 39.1226 47.4296C38.4926 46.7996 37.7126 45.8696 36.8126 44.6396C36.5126 44.2496 36.0626 43.5896 35.4026 42.6596C34.7426 41.6996 34.2026 40.9496 33.7226 40.3196C33.2426 39.7196 32.8526 39.2696 32.4026 38.8196C26.1926 42.0896 18.3326 41.0996 13.0826 35.8796C6.66258 29.4296 6.66258 18.9596 13.0826 12.5396C19.5326 6.08965 29.9726 6.08965 36.4226 12.5396ZM32.1926 31.6196C36.2726 27.5096 36.2726 20.8796 32.1926 16.7696C28.0826 12.6596 21.4226 12.6596 17.3426 16.7696C13.2326 20.8796 13.2326 27.5096 17.3426 31.6196C21.4226 35.7296 28.0826 35.7296 32.1926 31.6196Z" fill="white"/>
                </svg>
              </div>
            </div>
            <!-- <ion-button
              class="started-button"
              color="secondary"
              expand="block"
              [routerLink]="'/search/promotions'"
            >
              <span class="started-button-text">Book Now</span>
            </ion-button> -->
<!--            <p>Not sure where to start? Check <a routerLink="#howitworks">how it works</a>.</p>-->
          </div>
          <div class="hero-content__images">
            <div>
              <img class="hero-content__img" src="assets/images/yoga-card-min.jpg">
            </div>
            <div>
              <img class="hero-content__img" src="assets/images/dance-card-min.jpg">
            </div>
            <div>
              <img class="hero-content__img" src="assets/images/fitness-card-min.jpg">
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <ion-grid>
    <ion-row>
      <ion-col>
        <div class="text-center padding-extra">
          <div id="howitworks">
            <h2 class="bold title">
              Why use Promoga?
            </h2>
            <img
              src="assets/images/icon-4.jpg"
              width="90px"
            />
            <h5 class="bold subTitle">
              Find your ideal classes with independent instructors
            </h5>
            <p class="para-info">
              Book popular classes to relieve stress and get energized
            </p>
            <div class="bar-bg"></div>
            <img
              src="assets/images/icon-2.jpg"
              width="90px"
            />
            <h5 class="bold subTitle">
              Get advice from your instructor
            </h5>
            <p class="para-info">
              Message and get advice from your instructor in real-time on your mobile
            </p>
            <div class="bar-bg"></div>
            <img
              src="assets/images/icon-3.jpg"
              width="90px"
            />
            <br>
            <h5 class="bold subTitle">
              Make friends with like-minded people
            </h5>
            <p class="para-info">
              Connect with others at the AfterSocial following your class, and make new friends.
            </p>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <br>
  <div class="text-center padding-vertical instructor-section">
    <h5 class="text-uppercase bold instructor-title">
      Are you an instructor just getting started or looking to grow your community?
    </h5>
    <br>
    <div class="info-msg">
      <ion-grid>
        <ion-row>
          <ion-col size="3">
            <div class="text-center">
              <img src="assets/images/info-sign.png" width="40px" />
            </div>
          </ion-col>
          <ion-col size="9">
            <div>
                <h5>To become an instructor its best viewed in desktop site go to <b>www.promoga.com</b> on desktop.</h5>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>

  <ion-grid>
    <ion-row>
      <ion-col>
        <div class="footer text-center">
          <ul class="footer-links">
            <li>
              <a routerLink="/our-story">
                Our Story
              </a>
            </li>
            <li>
              <a routerLink="/privacy">
                Privacy Policy
              </a>
            </li>
            <li>
              <a routerLink="/terms-of-use">
                Terms of Use
              </a>
            </li>
            <li>
              <a href="https://help.promoga.com">
                Help
              </a>
            </li>
          </ul>
          <ul class="footer-social">
            <li>
              <a href="https://www.facebook.com/promoga" target="_blank">
                <img src="assets/images/fb-icon.jpg" width="37" height="42" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/promoga" target="_blank">
                <img src="assets/images/twitter-icon.jpg" width="37" height="42" />
              </a>
            </li>
            <li>
              <a href="https://instagram.com/livepromoga" target="_blank">
                <img src="assets/images/insta-icon.jpg" width="37" height="42" />
              </a>
            </li>
          </ul>
          <p>
            <small>
            &copy; {{copyright}} Promoga Technologies Inc.
            </small>
          </p>
          </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
